import { Component, Input } from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { ApiService }                    from '../../app-lite/api/api.service';
import { BookingsApiKeysModel }          from './models/bookings.api-keys';
import { BookingsApiSecretKeyComponent } from './bookings.api-secret-key.component';
import { CompanySettingsModel }          from '../../app-lite/companies/models/company.settings';
import { ConfirmService }                from '../../app-lite/messages/confirm/confirm.service';
import { MessagesService }               from '../../app-lite/messages/messages.service';
import { SessionService }                from '../../app-lite/sessions/session.service';

@Component({
  selector   : 'wor-bookings-api-key',
  template: require('./bookings.api-key.component.html')
})
export class BookingsApiKeyComponent {
  @Input() settings: CompanySettingsModel;

  constructor (
    private apiService     : ApiService,
    private confirmService : ConfirmService,
    private modalService   : NgbModal,
    private messagesService: MessagesService,
    private router         : UIRouter,
    public sessionService  : SessionService,
    public translateService: TranslateService
  ) {}

  generateApiKey () : void {
    this.confirmService.generic(this.translateService.instant('GENERAL_SPACE.MESSAGE.GENERATE_NEW_KEY'))
    .then(() => this.apiService.get('/company_settings/generate_public_booking_api_key'))
    .then(apiKeys => this.apiService.get('/company_settings/public_booking_api_company_id')
      .then(maskedCompanyId => {
        return {
          ...apiKeys,
          masked_company_id: maskedCompanyId.company_id
        };
      })
    )
    .then(( keys : BookingsApiKeysModel ) => {
      this.messagesService.show(this.translateService.instant('GENERAL_SPACE.MESSAGE.NEW_API_KEY_GENERATED'), 'success');

      const modal =  this.modalService.open(BookingsApiSecretKeyComponent, {
        size: 'lg'
      });

      modal.componentInstance.keys = keys;

      return modal.result;
    })
    .then(() => {
      this.router.stateService.reload();
    }).catch(err => {
      this.messagesService.error(err);
    });
  }
}